<template>
  <div>
    <ele-form
      v-model="formData"
      :form-desc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      :isShowBackBtn="false"
      @request-success="handleSuccess"
    />
  </div>
</template>
<script>
import * as user from "@/api/user.js";
export default {
  data() {
    let self = this;
    return {
      rules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 8, message: "密码长度最少8个字符", trigger: "blur" }
        ],
        confirm_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 8, message: "密码长度最少8个字符", trigger: "blur" }
        ]
      },
      formData: {},
      formDesc: {
        old_password: {
          type: "password",
          label: "旧密码"
        },
        password: {
          type: "password",
          label: "新密码"
        },
        confirm_password: {
          type: "password",
          label: "确认新密码"
        }
      }
    };
  },
  methods: {
    handleSubmit(data) {
      if (data.password != data.confirm_password) {
        this.$message({
          message: "俩次密码输入不一致",
          type: "error"
        });
        return;
      }
      user.upDataPassword.r(data).then(res => {});
    },
    handleSuccess() {}
  }
};
</script>
<style></style>
